import tw from 'twin.macro';
import { jsx } from '@emotion/react';

export const StyledForm = tw.form`pt-8 bg-white space-y-6 rounded-lg max-w-4xl mx-auto mb-4`;

export const FormSection = tw.div`md:inline-flex space-y-4 md:space-y-0 w-full p-4 text-gray-500 items-start`;

export const FormSectionHeader = tw.h2`md:w-1/3 max-w-md mx-auto`;

export const FormSectionBody = tw.div`md:w-2/3 max-w-md mx-auto`;
